import { CSSProperties, ReactElement, useCallback, useEffect, useState } from "react";
import { IParentSize } from "../../../types";
import EafComponent from "./eafComponent";
import LRFComponent from "./lrfComponent";
import CasterComponent from "./casterComponent";
import { useAsyncFetch } from "../../../system/useFetch";

import config from "./config.json";
import { IMachineOverview } from "./types";
import { useRealtimeValues } from "../../../system/websocketClient";

interface IProps {
  parentSize: IParentSize;
}

const scanInterval =  2000;

const Overview = ({ parentSize }: IProps): ReactElement => {
  const [ realtimeDispatch, realtime ] = useRealtimeValues();
  const [ firstTime, setFirstTime ] = useState(true);
  const [retry, setRetry] = useState(0);
  const [getOverviewData, { data }] = useAsyncFetch<Record<string, IMachineOverview>>();
  const [ overviewData, setOverviewData ] = useState<Record<string, IMachineOverview> | null>(null);
  // const [realtime, setRealtime] = useState<Record<string, IRealtimeData>>({});

  const updateOverview = useCallback((machine?: string) => {
    getOverviewData({
      module: "meltShop",
      query: "getOverview",
      payload: {
        machine
      }
    }).then(() => setFirstTime(false));
  }, []);

  useEffect(() => {
    if (!data) {
      return;
    }

    if (!overviewData) {
      setOverviewData(data);
    } else {
      const newRecord = { ...overviewData };

      Object.keys(data).map(k => {
        if (data[k]) {
          newRecord[k] = data[k];
        }
      });

      setOverviewData(newRecord);
    }
  }, [ data ]);

  useEffect(() => {
    realtimeDispatch({
      tags: config.realTimeTags,
      interval: scanInterval
    }, () => setRetry(prevState => prevState + 1));
  }, [realtimeDispatch, retry, setRetry]);


  // useEffect(() => {
  //   const newRecord: Record<string, IRealtimeData> = {};
  //
  //   Object.keys(realtimeData).map(k => {
  //     if (realtimeData[k]) {
  //       const isNumeric = !realtimeData[k].Type || realtimeData[k].Type === "N";
  //
  //       if (newRecord[k]) {
  //         newRecord[k].AcquisitionTimeStamp = realtimeData[k].AcquisitionTimeStamp;
  //         newRecord[k].Error = realtimeData[k].Error;
  //         newRecord[k].Value = isNumeric ? parseFloat(`${realtimeData[k].Value}`) : realtimeData[k].Value;
  //       } else {
  //         newRecord[k] = {
  //           AcquisitionTimeStamp: realtimeData[k].AcquisitionTimeStamp,
  //           Error: realtimeData[k].Error,
  //           Value: isNumeric ? parseFloat(`${realtimeData[k].Value}`) : realtimeData[k].Value
  //         };
  //       }
  //     } else {
  //       newRecord[k] = {
  //         AcquisitionTimeStamp: 0,
  //         Error: 1,
  //         Value: "---"
  //       };
  //     }
  //   });
  //
  //   setRealtime(newRecord);
  // }, [realtimeData]);

  const parentStyle: CSSProperties = {
    gridTemplateColumns: ".9fr .9fr 1.2fr",
    gridTemplateRows: "1fr",
    gap: ".5em",
    padding: ".5em",
    justifyItems: "stretch",
    alignItems: "stretch",
    justifyContent: "stretch",
    alignContent: "stretch",
    ...parentSize,
    maxHeight: parentSize.height
  };

  return (
    <div className="display-grid" style={parentStyle}>
      <EafComponent realtime={realtime} overviewData={overviewData?.EAF} updateOverview={updateOverview}  firstTime={firstTime} />
      <LRFComponent realtime={realtime} overviewData={overviewData?.LRF} updateOverview={updateOverview} firstTime={firstTime} />
      <CasterComponent realtime={realtime} overviewData={overviewData?.CASTER} updateOverview={updateOverview} firstTime={firstTime} />
    </div>
  );
};

export default Overview;